export class ActivitiesUpdateRequest {
  constructor ({
    contractId,
    deletedActivityIds,
    updatedActivities /* Array<ActivityUpdateRequest> */,
    newActivities /* Array<ActivityCreateRequest> */
  }) {
    this.contractId = contractId
    this.deletedActivityIds = deletedActivityIds
    this.updatedActivities = updatedActivities
    this.newActivities = newActivities
  }
}

export class ActivityCreateRequest {
  constructor ({
    effectiveDate,
    contractId,
    templateId,
    contractorId,
    runtimeCounterparty,
    recoveryMode,
    advanceId,
    baseCost, /* CostCalculationCreateRequest */
    activityDetails /* Array<ActivityDetailCreateRequest> */,
    deductFromActivityIdentifier,
    deductFromActivityId,
    namedRateId
  }) {
    this.effectiveDate = effectiveDate
    this.contractId = contractId
    this.templateId = templateId
    this.contractorId = contractorId
    this.runtimeCounterparty = runtimeCounterparty
    this.recoveryMode = recoveryMode
    this.advanceId = advanceId
    this.baseCost = baseCost
    this.activityDetails = activityDetails
    this.deductFromActivityIdentifier = deductFromActivityIdentifier
    this.deductFromActivityId = deductFromActivityId
    this.namedRateId = namedRateId
  }
}

export class ActivityUpdateRequest extends ActivityCreateRequest {
  constructor ({
    effectiveDate,
    contractId,
    templateId,
    contractorId,
    runtimeCounterparty,
    recoveryMode,
    advanceId,
    baseCost, /* CostCalculationUpdateRequest */
    activityDetails, /* Array<ActivityDetailUpdateRequest> */
    activityId,
    deductFromActivityIdentifier,
    deductFromActivityId,
    namedRateId
  }) {
    super({
      effectiveDate,
      contractId,
      templateId,
      contractorId,
      runtimeCounterparty,
      recoveryMode,
      advanceId,
      baseCost,
      activityDetails,
      deductFromActivityIdentifier,
      deductFromActivityId,
      namedRateId
    })
    this.activityId = activityId
  }
}

export class ActivityDetailCreateRequest {
  constructor ({ productId, rate }) {
    this.productId = productId
    this.rate = rate
  }
}

export class ActivityDetailUpdateRequest extends ActivityDetailCreateRequest {
  constructor ({ productId, rate, activityDetailId }) {
    super({ productId, rate })
    this.activityDetailId = activityDetailId
  }
}

export class CostCalculationCreateRequest {
  constructor ({
    rate,
    payBy,
    payOn,
    rateSheet
  }) {
    this.rate = rate
    this.payBy = payBy
    this.payOn = payOn
    this.rateSheet = rateSheet
  }
}

export class CostCalculationUpdateRequest extends CostCalculationCreateRequest {
  constructor ({
    rate,
    payBy,
    payOn,
    rateSheet,
    costCalculationId
  }) {
    super({
      rate,
      payBy,
      payOn,
      rateSheet
    })
    this.costCalculationId = costCalculationId
  }
}

export const ActivityRateChangeMode = {
  Schedule: 0,
  Overwrite: 1
}
